import { IconTypeNavigation } from "@slhuiicon/icon-core";
import {
  EVENT_SIDEBAR_TOGGLE,
  EVENT_SIDEBAR_CLOSED,
} from "@slhuinav/base/events";

/** Re-exported under the headerbar-facing name for backward compatibility */
export const SIDEBAR_ACTIVATOR_EVENT_CLICK = EVENT_SIDEBAR_TOGGLE;
export { EVENT_SIDEBAR_CLOSED };
export const NAVIGATION_LIST_OFFSET = "8";
export const CART_CHANGED_EVENT = "slhuinav:cart-changed";
export const ACTIVE_ORGANIZATION_ICON = "ico_singselector";
// Login item icon of the guest user menu
export const SIGN_IN_ICON = IconTypeNavigation.NAV_ACCOUNT;
export const ORGANIZATION_VISIBLE_ITEMS = 3;
export const ORGANIZATION_TITLE_MAX_CHARACTER = 35;
export const A11Y_OPEN_SIDEBAR_KEYCODES = [
  "Enter",
  "NumpadEnter",
  "Space",
  "ArrowDown",
];
export const DECIMAL_PLACES = 2;
